// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"D_-z","disabled":"E_-z","label":"F_-z"};